export const extractUtmParams = (search: string): string => {
  const params = new URLSearchParams(search);
  const utmParams = new URLSearchParams();

  params.forEach((value, key) => {
    if (key.startsWith("utm_")) {
      utmParams.set(key, value);
    }
  });

  return utmParams.toString();
};
